import { useEffect, useState } from "react";
import { selectWallpapersNarrow } from '../reducers/wallpapersNarrowReducer';
import { selectWallpapersWide } from '../reducers/wallpapersWideReducer';
import { useDispatch, useSelector } from "react-redux";
import { fetchWallpapersNarrow, fetchWallpapersWide } from "../fetch/documents";
import { useWindowSize } from "../utility/windowSize";



var interval = null;
// var images = Array.from({ length: 4 }, (_, i) => (i + 1).toString());



function BackGround() {
  const dispatch = useDispatch();
  const [width, height] = useWindowSize();



  const [image, setImage] = useState(1);
  const [transition, setTransition] = useState(false);

  const wallpapersNarrow = useSelector(selectWallpapersNarrow);
  const wallpapersWide = useSelector(selectWallpapersWide);
  function images() {
    if (width>=768) {
      return wallpapersWide;
    }
    return wallpapersNarrow;
  }
  useEffect(() => {
    if (transition) {
      let t = setTimeout(() => {
        let broj = Math.floor(Math.random() * images().length);

        setImage(broj);

      }, 500);

      return () => clearTimeout(t);
    }

  }, [transition]);
  useEffect(() => {

    let t = setTimeout(() => {
      setTransition(false);

    }, 500);

    return () =>clearTimeout(t)
  }, [image])
  useEffect(() => {

    dispatch(fetchWallpapersNarrow());
    dispatch(fetchWallpapersWide());

    function backgroundJob() {
      // let broj = slika.toString().padStart(2, '0');
      setTransition(true);
    }
    let bginterval = setInterval(backgroundJob, 10000);
    return () => clearInterval(bginterval);

  }, []);
  return (
    <div className="absolute top-0 left-0 w-full h-full">

      {

        images().map((a, i) => {


          return (
            <img
              // src={"https://www.mb51p.com/foto/TT/TT" + a + ".jpg"}
              src={a.линк}
              class={(i == image ? "opacity-100 " : " opacity-0 ") + "  transition-opacity duration-1000 absolute top-0 left-0 w-full h-full object-cover"}
            />);
        })
        // images.map((a, i) => {


        //   return (
        //     <img
        //       // src={"https://www.mb51p.com/foto/TT/TT" + a + ".jpg"}
        //       src={require("../images/" + a + ".jpg")}
        //       class={(a == image ? "opacity-100 " : " opacity-0 ") + "  transition-opacity duration-1000 absolute top-0 left-0 w-full h-full object-cover"}
        //     />);
        // })
      }
      <div
        // src={"https://www.mb51p.com/foto/TT/TT" + a + ".jpg"}

        class={(transition ? "opacity-100 " : " opacity-0 ") + " z-1 transition-opacity duration-1000 absolute top-0 left-0 w-full h-full object-cover backdrop-blur-lg"}
      />
    </div>

  );
}

export default BackGround;
